<div class="gmail" (click)="googleAuthenticate()" id="google-login-button">
  <a style="color: #662d91">
    <a>התחבר</a>
    <span style="font-weight: bolder; font-size: 19px"> </span>
  </a>
</div>
